import { useCallback, useMemo, useRef, useState } from 'react';
import { PlannerMapDataElement, VisibleAsset } from 'components/common/types/Planner.types';
import { areMapDataArraysEqual } from '../PlannerMap/utils/areMapDataArraysEqual';

interface UseClusterAssetsDataParams {
  filteredAssets: VisibleAsset[];
  mapAssetsToMapElements: (assets: VisibleAsset[]) => PlannerMapDataElement[];
}

export const useClusterAssetsData = ({
  filteredAssets,
  mapAssetsToMapElements,
}: UseClusterAssetsDataParams): {
  clusterAssetsData: PlannerMapDataElement[];
  handleViewportChange: (data: PlannerMapDataElement[]) => void;
  mapData: PlannerMapDataElement[];
} => {
  const clusterAssetsData = useMemo<PlannerMapDataElement[]>(
    () => mapAssetsToMapElements(filteredAssets),
    [mapAssetsToMapElements, filteredAssets],
  );

  const [mapData, setMapData] = useState<PlannerMapDataElement[]>([]);
  const mapDataRef = useRef(mapData);

  const handleViewportChange = useCallback((data: PlannerMapDataElement[]): void => {
    if (areMapDataArraysEqual(data, mapDataRef.current)) return;

    mapDataRef.current = data;
    setMapData(data);
  }, []);

  return {
    clusterAssetsData,
    handleViewportChange,
    mapData,
  };
};
